<template>
    <div class="uploader-bg">
        <uploader v-model="fileList" :after-read="afterRead" :max-count="3" :max-size="1024 * 1024 * 10"
            accept="image/png,image/jpeg,image/jpg" :preview-size="60" :preview-options="{closeable: true}"
            @oversize="onOversize" />
    </div>
</template>

<script>
    import {
        Toast,
        Uploader
    } from 'vant'
    import Request from '@request'
    import api from '@api'
    import host from '@host'

    export default {
        components: {
            Uploader
        },
        props: {
            content: {
                type: Object,
                require: false,
                defalut: {}
            }
        },
        data() {
            return {
                fileList: []
            }
        },
        created() {

        },
        methods: {
            afterRead(file) {
                file.status = 'uploading'
                file.message = '上传中...'
                Request.post(api.common.upload, {
                    file: file.file,
                }).then(res => {
                    const {
                        data
                    } = res
                    file.status = 'done'
                    file.url = data.oss_url
                }).catch(error => {
                    file.status = 'failed'
                    file.message = '上传失败'
                })
            },
            onOversize(file) {
                Toast('文件大小不能超过10M')
            },
            getFileList() {
                return this.fileList.map(file => {
                    return file.url
                }).join(',')
            }
        }

    }
</script>

<style scoped>

</style>